import { z } from "zod";

import { ActionPolicySchema } from "./actionPolicy.schema";

/**
 * AccessCardPoliciesSchema — the `policies` Json field on AccessCard.
 *
 * Shape: Record<actionId, ActionPolicy>
 * - Key: namespaced action ID (e.g. "gmail:send_email", "slack:send_message")
 * - Value: action-level policy with per-parameter enabled/disabled overrides
 *
 * Conventions:
 * - Master card: `{}` (empty object = all actions allowed, all parameters enabled)
 * - Derived card: only listed actions are allowed. Unlisted actions = blocked.
 * - Within an action: unlisted parameters are disabled (stripped from the API call)
 */
export const AccessCardPoliciesSchema = z.record(z.string(), ActionPolicySchema);

export type AccessCardPolicies = z.infer<typeof AccessCardPoliciesSchema>;
